import { Token } from 'domain/models';
import { Api } from 'domain/core';

export class AuthorizationService {
	static logout() {
		try {
			AuthorizationService.removeAuthorization();
		} catch (err) {
			throw new Error('AuthorizationService :: Unable to logout!');
		}
	}

	static safeGetAuthorization(): Token | undefined {
		try {
			return AuthorizationService.getAuthorization();
		} catch (err) {
			return undefined;
		}
	}

	static getAuthorization(): Token {
		try {
			const auth = localStorage.getItem('auth:token');
			return JSON.parse(auth ?? '') as Token;
		} catch (err) {
			throw new Error(
				'AuthorizationService :: Unable to retrieve authorization!'
			);
		}
	}

	static saveAuthorization(token: Token) {
		localStorage.setItem('auth:token', JSON.stringify(token));
	}

	static removeAuthorization() {
		localStorage.removeItem('auth:token');
	}

	/**
	 * @deprecated
	 * @param param email / password object
	 * @returns
	 */
	static login({
		password,
		email,
	}: {
		password: string;
		email: string;
	}): Promise<Token> {
		return fetch(Api.baseUrl + Api.auth.login, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ username: email, password }),
		})
			.then((r) => r.json())
			.then((token) => {
				AuthorizationService.saveAuthorization({
					...token,
					expires_in: 50000,
				});
				return token;
			});
	}

	static renew(): Promise<Token> {
		try {
			const token = AuthorizationService.getAuthorization();
			return fetch(Api.baseUrl + Api.auth.renew, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token.access_token}`,
				},
			})
				.then((res: Response) => {
					if (res.status === 200) {
						return res.json();
					}
					// Redirect to login
					AuthorizationService.removeAuthorization();
					AuthorizationService.doLogin();
				})
				.then((token: Token) => {
					AuthorizationService.saveAuthorization(token);
					return token;
				});
		} catch (err) {
			window.location.href = '/login?error=expired';
			return Promise.reject(
				new Error('AuthorizationService :: Unable to renew token!')
			);
		}
	}
	static doLogin() {
		window.location.href = '/login';
	}
}
